import moment = require("moment");

export const getTime = (time: string): Date => {
	return moment(`2010-01-02 ${time}`).toDate();
};